"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TikTokSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var TikTokSVG = function TikTokSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.988 9.01a6.774 6.774 0 0 1-4.16-1.424 7.095 7.095 0 0 1-2.616-4.263A7.263 7.263 0 0 1 21.079 2h-4.46v12.492l-.006 6.843c0 1.83-1.162 3.38-2.773 3.926a3.961 3.961 0 0 1-3.345-.377 4.158 4.158 0 0 1-1.973-3.487c-.034-2.313 1.79-4.199 4.045-4.199.445 0 .873.075 1.273.21v-4.641a8.565 8.565 0 0 0-1.286-.098c-2.468 0-4.777 1.052-6.427 2.947a8.687 8.687 0 0 0-2.11 5.173c-.152 2.516.746 4.908 2.489 6.673A8.423 8.423 0 0 0 12.555 30a8.448 8.448 0 0 0 6.048-2.538 8.664 8.664 0 0 0 2.505-6.092l-.024-10.218a11.2 11.2 0 0 0 2.506 1.498 11.03 11.03 0 0 0 4.41.911V9.01h-.012z",
    stroke: "none"
  }));
};
exports.TikTokSVG = TikTokSVG;
TikTokSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TikTokSVG);
exports.default = _default;